/*
 * @Author: huangzq
 * @Date: 2019-09-12 10:44:38
 * @Last Modified by: zhouwei
 * @Last Modified time: 2020-07-20 16:22:12
 * @Desc: 搜索组件-已和【服务商后台】保持一致了
*/
<template>
  <div class="search-line">
    <!-- 标签多选组件 -->
    <!-- <tag-select
      v-if="showTagSelect"
      v-model="searchParams.tags"
      :tip="false"
      :max-num="0"
      @change="returnSearchParam"
    /> -->
    <tag-select-cascader
      v-model="levelTags"
      width="320"
      @change="tagChange"
    />

    <!-- 状态筛选 -->
    <mk-select
      v-model="searchParams.status"
      :option="statusOptions"
      placeholder="状态"
      @change="returnSearchParam"
    />

    <!-- 标题输入框 -->
    <mk-input
      v-model="searchParams.title"
      width="200"
      maxlength="20"
      placeholder="输入标题"
      clearable
      class="title-input"
      @clear="returnSearchParam"
      @keyup.enter.native="returnSearchParam"
    >
      <div
        slot="suffix"
        class="el-input__icon"
      >
        <i
          class="el-icon-search"
          @click="returnSearchParam"
        />
      </div>
    </mk-input>
    <mk-button-biz @click="resetFun">
      重置
    </mk-button-biz>
  </div>
</template>

<script>
import tagSelectCascader from '@components/tag-select-cascader'

export default {
  name: 'SearchLine',

  components: { tagSelectCascader },

  props: {
    // * 所有状态选项
    statusOptions: {
      type: Array,
      default () {
        return [
          {
            value: '',
            label: '全部状态'
          },
          {
            value: 0,
            label: '未发布'
          },
          {
            value: 1,
            label: '已发布'
          },
          {
            value: 2,
            label: '已下线'
          }
        ]
      }
    },

    // 是否显示标签搜索
    showTagSelect: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      // * 搜索条件的字段
      searchParams: {
        title: '',
        tags: [],
        status: ''
      },
      levelTags: []
    }
  },
  activated () {
    this.returnSearchParam()
  },
  methods: {
    /**
     * * 标签change事件
     */
    tagChange () {
      this.searchParams.tags = this.util.levelTagsToTags(this.levelTags)
      this.returnSearchParam()
    },
    /**
     * * 重置搜索条件方法
     */
    resetFun () {
      this.searchParams = {
        title: '',
        tags: [],
        status: ''
      }
      this.levelTags = []
      this.returnSearchParam()
    },

    /**
     * * 将搜索条件返回给父组件
     */
    returnSearchParam () {
      const searchParams = {}
      // 循环，将空字符串的key去掉
      for (const key in this.searchParams) {
        if (this.searchParams.hasOwnProperty(key)) {
          const val = this.searchParams[key]
          let isVal = val !== ''
          if (Array.isArray(val)) isVal = val.length
          if (isVal) searchParams[key] = val
        }
      }
      this.$emit('on-search', searchParams)
    }
  }
}
</script>

<style lang='scss' scoped>
.search-line {
  display: flex;
  min-height: 32px;
  margin: 10px 20px;

  .tag-select,
  .el-select,
  .el-input {
    margin-right: 10px;
  }

  & /deep/ .tag-select {
    .tag-tip {
      display: none;
    }
  }

  .title-input {
    // line-height: normal !important;
    height: 32px !important;
    line-height: 32px !important;

    & /deep/ .el-input__inner {
      height: 32px !important;
      line-height: 32px !important;
      padding-right: 50px;
    }

    & /deep/ .el-input__suffix {
      .el-input__clear {
        position: absolute;
        top: 0;
        left: -25px;
      }
    }
  }

  .tag-select-cascader {
    margin-right: 10px;
  }
}
</style>
